import LoginForm from '../Authentication/LoginForm'

const LoginPage = () => {
  return <LoginForm />
}

export default LoginPage
